import { Component } from '@angular/core';
import { Apiservice } from '../../../../../services/ApiService';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-gate',
  templateUrl: './add-gate.component.html',
  styleUrl: './add-gate.component.scss'
})
export class AddGateComponent {
  newGateName: string = '';
  selectedVenue: string = '';
  gatesArray: any = [];

  constructor(private _http: HttpClient, private router:Router, private apiservice:Apiservice) {}

  onGateNameChange(event: any) {
    this.newGateName = event?.target?.value;
  }

  addGate() {
    if (this.newGateName) {
      this.apiservice.getGates(this.selectedVenue).subscribe((result: any) => {
        const existingGates = result.gates || []; 
        existingGates.push(this.newGateName);
        const body = {
          venue: this.selectedVenue,
          gates: existingGates, 
        };
  
        this._http
          .post(
            'https://57hb9ue4x9.execute-api.ap-southeast-2.amazonaws.com/prod/gates',
            body
          )
          .subscribe({
            next: (data) => {
              this.router.navigate(['tools/gates']);
            },
            error: (error) => {
              console.error('Error adding gate:', error);
            },
          });
      });
    } else {
      console.error('New gate name cannot be empty');
    }
  }

  ngOnInit() {
      this.gatesArray = history.state.gates;
      this.selectedVenue = history.state.Selectedvenue;
  }

}
